enum MutationNames {
  SET_ELASTIC_ENROLLMENT_ID = 'SET_ELASTIC_ENROLLMENT_ID',
  LOAD_FORM_DATA_REQUESTED = 'LOAD_FORM_DATA_REQUESTED',
  LOAD_FORM_DATA_SUCCEEDED = 'LOAD_FORM_DATA_SUCCEEDED',
  LOAD_ELASTIC_FORM_DATA_REQUESTED = 'LOAD_ELASTIC_FORM_DATA_REQUESTED',
  LOAD_ELASTIC_FORM_DATA_SUCCEEDED = 'LOAD_ELASTIC_FORM_DATA_SUCCEEDED',
  SET_SHOULD_DISABLE_FORM_FIELDS_TRUE = 'SET_SHOULD_DISABLE_FORM_FIELDS_TRUE',
  SET_SHOULD_DISABLE_FORM_FIELDS_FALSE = 'SET_SHOULD_DISABLE_FORM_FIELDS_FALSE'
}

export default MutationNames;